/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  conferencerules: [],
  error: null,
};

const getters = {
  conferencerules: state => state.conferencerules,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    return Vue.http.get(`${getApiPath(payload.user)}/products/${payload.id}/conferencerules`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, conferencerules) {
    state.conferencerules = [];
    if (conferencerules.data.items) {
      conferencerules.data.items.forEach((el) => {
        state.conferencerules.push(el);
      });
    }
    state.error = null;
  },
  [mTypes.REMOVE_DATA](state, conferenceruleId) {
    const index = state.conferencerules.findIndex(obj => obj.id === conferenceruleId);
    state.conferencerules.splice(index, 1);
  },
  [mTypes.CLEAR_STATE](state) {
    state.conferencerules = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/conferencerules/conferencerules.js